var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"bottom-five",attrs:{"title":"困人趋势"}},[_c('LineCharts',{attrs:{"id":"xsbjqs","lists":_vm.datas,"areaColor":_vm.areaColor,"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }